import React from 'react';
import { ChevronLeft } from 'lucide-react';
import { generatePath, useNavigate } from 'react-router';
import { Button } from '@/Components/shadcn/button';
import UIStrings from '@/Utils/UIStrings';
import { useInvitationPageContext } from '../Contexts/InvitationPageContext';
import useCompanyId from '@/Hooks/UseCompanyId';
import RoutePath from '@/Routing/RoutePath';

function BackButton(): React.JSX.Element {
    const navigate = useNavigate();
    const companyId = useCompanyId();
    const { returnURL: from, clientId } = useInvitationPageContext();

    const handleOnClick = () => {
        const recruitmentOverviewPath = generatePath(RoutePath.AssessmentsActive, { companyId, clientId });
        const nextLocation = from || recruitmentOverviewPath;
        navigate(nextLocation);
    };

    return (
        <Button variant="ghost" size="sm" className="gap-1 px-0 pr-1" onClick={handleOnClick}>
            <ChevronLeft className="size-4" style={{ pointerEvents: 'auto' }} data-testid="ChevronLeftIcon" />
            {UIStrings.Back}
        </Button>
    );
}

export default BackButton;
